import React from "react";
import { MdClose } from "react-icons/md";
import { InfoIcon } from "@phosphor-icons/react";

export const ENERGY_COMMUNITY_LIKELY_QUALIFIES = "Likely Qualifies";

type OpportunityEnergyCommunityFields = {
    EnergyCommunityStatus?: string | null;
    energyCommunityStatus?: string | null;
};

export const opportunityLikelyQualifiesAsEnergyCommunity = (
    opportunity: OpportunityEnergyCommunityFields | null | undefined,
): boolean => {
    const status = opportunity?.EnergyCommunityStatus ?? opportunity?.energyCommunityStatus;
    return String(status ?? "").trim().toLowerCase() === ENERGY_COMMUNITY_LIKELY_QUALIFIES.toLowerCase();
};

/** Prefer sites-API status when oneButton opportunity detail omits EnergyCommunityStatus. */
export const resolveEnergyCommunityLikelyQualifies = (
    opportunity: OpportunityEnergyCommunityFields | null | undefined,
    energyCommunityStatus?: string | null,
): boolean => {
    if (energyCommunityStatus != null && String(energyCommunityStatus).trim() !== '') {
        return (
            String(energyCommunityStatus).trim().toLowerCase() ===
            ENERGY_COMMUNITY_LIKELY_QUALIFIES.toLowerCase()
        );
    }
    return opportunityLikelyQualifiesAsEnergyCommunity(opportunity);
};

type EnergyCommunityNoticeProps = {
    onClose: () => void;
};

const stopCanvasGesture = (event: React.SyntheticEvent) => {
    event.stopPropagation();
};

const EnergyCommunityNotice: React.FC<EnergyCommunityNoticeProps> = ({ onClose }) => {
    const handleClose = (event: React.SyntheticEvent) => {
        event.preventDefault();
        event.stopPropagation();
        onClose();
    };

    return (
        <div
            className="energy-community-notice"
            role="status"
            onPointerDown={stopCanvasGesture}
            onTouchStart={stopCanvasGesture}
            onMouseDown={stopCanvasGesture}
        >
            <div className="energy-community-notice__header">
                <div className="energy-community-notice__header-text">
                    <InfoIcon size={24} />
                    <span className="energy-community-notice__title">Energy Community</span>
                </div>
                <button
                    type="button"
                    className="energy-community-notice__close"
                    aria-label="Dismiss energy community notice"
                    onPointerDown={handleClose}
                    onClick={handleClose}
                >
                    <MdClose size={20} />
                </button>
            </div>
            <p className="energy-community-notice__description">
                This property likely qualifies as an energy community.
            </p>
        </div>
    );
};

export default EnergyCommunityNotice;
